// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"f2438686","243":"062c2623","662":"c8733948"}[chunkId] + ".chunk.js";
};